import apiService from "@/core/services/apiService";

export type State = { classes: object };
import {Module, VuexModule, Mutation, Action} from "vuex-module-decorators";
import {Actions, Mutations} from "@/store/enums/store.enums";
import {CheckoutActions, CheckoutMutation} from "@/modules/checkout/store/enums";

@Module
export default class Store extends VuexModule {
    renderKey = 1;
    listParams = {
        page: 1,
        results: 10,
        search: null,
        sort: [],
        filter: {}
    };
    listCache = [];
    listTotal = 0;

    get getCheckoutReminderList() {
        return this.listCache;
    }

    get getCheckoutReminderTotal() {
        return this.listTotal;
    }

    get getCheckoutRenderKey() {
        return this.renderKey;
    }

    @Mutation
    [CheckoutMutation.SET_REMINDER_LIST]({listParams, listTotal, listCache}) {
        this.listParams = listParams;
        this.listCache = listCache;
        this.listTotal = listTotal;
    }

    @Action
    [CheckoutActions.FETCH_REMINDER_LIST](params) {

        return new Promise<void>((resolve, reject) => {

            apiService.post("checkout/reminder-list", params).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(CheckoutMutation.SET_REMINDER_LIST, {
                    listParams: params,
                    listTotal: data.results,
                    listCache: data.result
                });
                resolve();

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [CheckoutActions.REFRESH_REMINDER_LIST]() {

        this.context.dispatch(CheckoutActions.FETCH_REMINDER_LIST, this.listParams);

    };

    @Action
    [CheckoutActions.RESOLVE_REMINDER](owner) {

        return new Promise((resolve, reject) => {

            apiService.get(`checkout/reminder-resolve/${owner}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [CheckoutActions.DELETE_REMINDER](statId) {

        return new Promise((resolve, reject) => {

            apiService.delete(`checkout/reminder-delete/${statId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

}
